module.exports = __webpack_public_path__ + "media/images/redesign-images/home/affiliate-collage-placeholder-3a44ea752ed85a32e177b19840513780.jpg";